import { withHandlers } from 'recompose';

export default withHandlers({
  addItemsToMenu: props => () => {
  }
})